import script from "./SupplierForecastSaveButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupplierForecastSaveButton.vue?vue&type=script&setup=true&lang=ts"

import "./SupplierForecastSaveButton.vue?vue&type=style&index=0&id=0f51ccaa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f51ccaa"]])

export default __exports__